document.addEventListener("DOMContentLoaded", () => {
    const desktopNav = document.querySelector(".side-navigation--desktop");
    const mobileNav = document.querySelector(".side-navigation--mobile");
    const desktopLinks = desktopNav?.querySelectorAll(".side-navigation-link");
    const mobileLinks = mobileNav?.querySelectorAll(".side-navigation-link");
    const sections = document.querySelectorAll("[data-section-anchor]");
    const toggle = mobileNav?.querySelector(".side-navigation-toggle");
    const mobileList = mobileNav?.querySelector(".side-navigation-list");
    const currentSectionEl = mobileNav?.querySelector("[data-current-section]");

    if (
        !desktopNav ||
        !mobileNav ||
        !desktopLinks?.length ||
        !mobileLinks?.length ||
        sections.length === 0
    )
        return;

    // Mobile toggle functionality
    const toggleMobileNav = (forceClose = false) => {
        if (!toggle || !mobileList) return;

        const isExpanded = toggle.getAttribute("aria-expanded") === "true";
        const shouldClose = forceClose || isExpanded;

        toggle.setAttribute("aria-expanded", String(!shouldClose));
        mobileList.setAttribute("aria-hidden", String(shouldClose));
        mobileNav.classList.toggle("is-expanded", !shouldClose);
    };

    toggle?.addEventListener("click", () => toggleMobileNav());

    // Close mobile nav when clicking outside
    document.addEventListener("click", (e) => {
        if (!mobileNav.contains(e.target)) {
            toggleMobileNav(true);
        }
    });

    // Update current section display
    const updateCurrentSection = (label) => {
        if (currentSectionEl) {
            currentSectionEl.textContent = label;
        }
    };

    // Get header height for offset calculations
    const getHeaderOffset = () => {
        const isHidden = document.body.classList.contains("header-hidden");
        if (isHidden) return 0;
        const totalHeight = parseInt(
            getComputedStyle(document.documentElement).getPropertyValue("--header-total-height")
        ) || 0;
        return totalHeight;
    };

    // Intersection Observer for scroll spy
    // Use fixed rootMargin that accounts for header area
    const headerHeight = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue("--header-total-height")
    ) || 100;
    const observerOptions = {
        root: null,
        rootMargin: `-${headerHeight + 20}px 0px -60% 0px`,
        threshold: 0,
    };

    const observerCallback = (entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const sectionId = entry.target.getAttribute("data-section-anchor");
                if (sectionId) {
                    // Update desktop links
                    desktopLinks.forEach((link) => {
                        link.classList.remove("is-active");
                        if (link.getAttribute("data-section") === sectionId) {
                            link.classList.add("is-active");
                        }
                    });

                    // Update mobile links and current section display
                    mobileLinks.forEach((link) => {
                        link.classList.remove("is-active");
                        if (link.getAttribute("data-section") === sectionId) {
                            link.classList.add("is-active");
                            const label = link.getAttribute("data-label");
                            if (label) updateCurrentSection(label);
                        }
                    });
                }
            }
        });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    sections.forEach((section) => {
        observer.observe(section);
    });

    // Smooth scroll on click with offset (for both desktop and mobile)
    const handleLinkClick = (link, isMobile = false) => {
        link.addEventListener("click", (e) => {
            e.preventDefault();
            const sectionId = link.getAttribute("data-section");
            const targetSection = document.querySelector(
                `[data-section-anchor="${sectionId}"]`
            );
            if (targetSection) {
                const offsetTop =
                    targetSection.getBoundingClientRect().top + window.pageYOffset;

                // Scrolling up → header will reappear, account for it
                // Scrolling down → header will hide, no header offset needed
                const scrollingUp = offsetTop < window.pageYOffset;
                const headerTotal = scrollingUp
                    ? parseInt(
                          getComputedStyle(document.documentElement).getPropertyValue(
                              "--header-total-height"
                          )
                      ) || 100
                    : 0;
                const padding = 24;
                const mobileFixed = isMobile ? -100 : 0;
                const offset = isMobile
                    ? headerTotal + padding + mobileNav.offsetHeight + mobileFixed
                    : headerTotal + padding;

                window.scrollTo({
                    top: offsetTop - offset,
                    behavior: "smooth",
                });

                // Close mobile nav after clicking a link
                if (isMobile) {
                    toggleMobileNav(true);
                }
            }
        });
    };

    desktopLinks.forEach((link) => handleLinkClick(link));
    mobileLinks.forEach((link) => handleLinkClick(link, true));
});
